// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.bg-progress {
  position: relative;
  display: flex;
  flex-direction: column;
  top: -10px;
}

.bg-progress-bar {
  width: 100%;
  height: 3px;
  background-color: #f5f5f5;
  margin-bottom: 10px;
}

.bg-progress-bar-fill {
  background-color: rgb(72, 127, 135);
  transition: width 0.3s ease;
  height: 3px;
}

.bg-progress-icon {
  vertical-align: middle;
  flex-direction: column;
  width: 16px;
  height: 16px;
  margin-right: 6px;
}

.bg-progress-icon svg {
  width: 16px;
  height: 16px;
  margin: 0;
  padding: 0;
}

.bg-progress-body {
  display: flex;
  flex-direction: row;
}

.bg-progress-text {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  font-size: 14px;
  line-height: 17px;
}

.bg-progress-message {
  text-align: left;
  margin-right: auto;
  vertical-align: middle;
}

.bg-progress-description {
  text-align: right;
  margin-left: auto;
  vertical-align: middle;
}

@keyframes rotating {
  to {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  from {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.rotating {
  -webkit-animation: rotating 1s linear infinite;
  -moz-animation: rotating 1s linear infinite;
  -ms-animation: rotating 1s linear infinite;
  -o-animation: rotating 1s linear infinite;
  animation: rotating 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/components/BackgroundProgressBar/BackgroundProgressBar.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;IAC/B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,iCAAiC;IACjC,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE,8CAA8C;EAC9C,2CAA2C;EAC3C,0CAA0C;EAC1C,yCAAyC;EACzC,sCAAsC;AACxC","sourcesContent":["\n.bg-progress {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  top: -10px;\n}\n\n.bg-progress-bar {\n  width: 100%;\n  height: 3px;\n  background-color: #f5f5f5;\n  margin-bottom: 10px;\n}\n\n.bg-progress-bar-fill {\n  background-color: rgb(72, 127, 135);\n  transition: width 0.3s ease;\n  height: 3px;\n}\n\n.bg-progress-icon {\n  vertical-align: middle;\n  flex-direction: column;\n  width: 16px;\n  height: 16px;\n  margin-right: 6px;\n}\n\n.bg-progress-icon svg {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  padding: 0;\n}\n\n.bg-progress-body {\n  display: flex;\n  flex-direction: row;\n}\n\n.bg-progress-text {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 14px;\n  line-height: 17px;\n}\n\n.bg-progress-message {\n  text-align: left;\n  margin-right: auto;\n  vertical-align: middle;\n}\n\n.bg-progress-description {\n  text-align: right;\n  margin-left: auto;\n  vertical-align: middle;\n}\n\n@keyframes rotating {\n  to {\n    -ms-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -webkit-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  from {\n    -ms-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -webkit-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.rotating {\n  -webkit-animation: rotating 1s linear infinite;\n  -moz-animation: rotating 1s linear infinite;\n  -ms-animation: rotating 1s linear infinite;\n  -o-animation: rotating 1s linear infinite;\n  animation: rotating 1s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
